// @flow
import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import {
  FETCH_STEP,
  FETCH_STEP_SUCCESS,
  FETCH_STEP_FAILURE,
  SAVE_STEP,
  SAVE_STEP_SUCCESS,
  SAVE_STEP_FAILURE,
  SAVE_STATS_RADIO_PLAYER,
} from '../actions/radioConfigurationActions';
import { INITIAL_DATA } from '../domain/PlayerConfiguration';
import type { StatsRadioPlayerData } from '../domain/PlayerConfiguration';

export type RadioConfigurationState = {
  fetching: boolean,
  error: ?Object,
  step: ?RadioConfigurationStep;
  statsRadioPlayer: StatsRadioPlayerData,
};

export const INITIAL_STATE: RadioConfigurationState = {
  fetching: false,
  error: undefined,
  step: undefined,

  statsRadioPlayer: INITIAL_DATA.statsRadioPlayer,
};

export default (state: RadioConfigurationState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case FETCH_STEP:
      return {
        ...state,
        error: undefined,
        fetching: true,
        step: undefined,
      };
    case FETCH_STEP_SUCCESS:
      return {
        ...state,
        step: action.step,
        fetching: false,
        error: undefined,
      };
    case FETCH_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
        fetching: false,
      };
    case SAVE_STEP:
      return {
        ...state,
        error: undefined,
      };
    case SAVE_STEP_SUCCESS:
      return {
        ...state,
        error: undefined,
      };
    case SAVE_STEP_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case SAVE_STATS_RADIO_PLAYER:
      return {
        ...state,
        statsRadioPlayer: action.statsRadioPlayer,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/reducers/radioConfigurationReducer.js